module.exports = __webpack_public_path__ + "img/logo_fmi-300x150.839b5bf4.png";